import { PlaybookType } from './types'

export const copyToClipboard = async (text = '') => {
    if ('clipboard' in navigator) {
        return await navigator.clipboard.writeText(text)
    } else {
        return new Promise(res => {
            document.execCommand('copy', true, text)
            res({})
        })
    }
}

export const copyHTMLToClipboard = async (html: string) => {
    const blob = new Blob([html], { type: 'text/html' })
    //@ts-ignore
    const data = [new ClipboardItem({ 'text/html': blob })]

    return navigator.clipboard.write(data)
}

export const validateEmail = (email: string) => {
    const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return re.test(String(email).toLowerCase())
}

export const generateStartValue = (time: number) => {
    const value = Math.floor(time)
    const data = formatTime(value).split(':')
    if (data.length < 3) data.unshift('00')

    return data.join(':')
}

const formatTime = (seconds: number, showHours = false) => {
    const format = (val: number) => `0${Math.floor(val)}`.slice(-2)

    const hours = seconds / 3600
    const minutes = (seconds % 3600) / 60
    const secs = seconds % 60

    const h = hours >= 1 || showHours ? [hours] : []

    return [...h, minutes, secs].map(format).join(':')
}

export const timeToSeconds = (time: any) => {
    if (!time) return 0

    return time
        .split(':')
        .reverse()
        .reduce(
            (prev: number, curr: number, i: number) =>
                prev + curr * Math.pow(60, i),
            0
        )
}

export const option = (value: string, label: string) => ({ value, label })

type CopyLinkGifProps = {
    playbook: PlaybookType
    copyLinkPath: string
    uid: string
    isQuickGuidde: boolean
    trackLinkName?: string
    trackLinkId?: string
    trackLink?: string
    origin?: string
}

export const copyLinkedGif = ({
    playbook,
    copyLinkPath,
    uid,
    origin = window.location.origin,
    isQuickGuidde,
    trackLinkName,
    trackLinkId,
    trackLink
}: CopyLinkGifProps) => {
    const { gifUrl, screenshotUrl } = playbook

    const urlParams = new URLSearchParams()

    if (trackLinkName) {
        urlParams.append('track_link_name', trackLinkName)
    }
    if (trackLinkId) {
        urlParams.append('track_link_id', trackLinkId)
    }

    urlParams.append('origin', uid)

    const link = `${origin}${copyLinkPath}?${urlParams.toString()}`

    const width = isQuickGuidde ? '700px' : '250px'
    const height = isQuickGuidde ? 'auto' : '175px'

    const imageHtml = `
         <table width:100%">
              <style>
                 a {
                     font-size: 16px;
                     text-decoration: underline;
                 }
                 img {
                     object-fit: contain;
                     border-radius: 2px;
                 }
                 tr {
                    background-color: white;
                 }
             </style>
             <tr>
                 <td>
                     <a href=${link}>${playbook.title}</a>
                 </td>
             </tr>
             <tr>
                 <td>
                 <a href=${link} >
                     <img width=${width} height=${height}  alt="" src=${
        gifUrl || screenshotUrl
    } />
                 </a>
                 </td>
             </tr>
             ${
                 trackLink
                     ? `<tr><td><a href=${trackLink}>Track link</a></td></tr>`
                     : ''
             }
         </table>
         `

    return copyHTMLToClipboard(imageHtml)
}

export const capitalize = (str?: string) => {
    return str ? str.charAt(0).toUpperCase() + str.slice(1) : ''
}
